import { notification as antdNotification } from 'antd'
import React from 'react'
import { NOTIFICATION_ACTIONS, NOTIFICATION_TYPES } from '../constants/notification-types'
import MbaUpgradeActions from '../components/common/notifications/actions/MbaUpgradeActions'
import ZipExportReadyActions from '../components/common/notifications/actions/ZipExportReadyActions'
import { getNotification } from '../components/common/AntdStaticFunctionHolder'

export const openNotificationWithIcon = (type, message, description, key, actions, dataTest) => {
    // Use themed notification from App.useApp() if available, fallback to static
    const notification = getNotification() || antdNotification
    notification[type]({
        key: key || message,
        message: <div dangerouslySetInnerHTML={{ __html: message }} />,
        description: description,
        btn: actions,
        props: dataTest ? { 'data-test': dataTest } : undefined,
    })
}

export const getNotificationType = type => {
    if (type === NOTIFICATION_TYPES.SUCCESS) {
        return 'success'
    } else if (type === NOTIFICATION_TYPES.WARNING) {
        return 'warning'
    } else if (type === NOTIFICATION_TYPES.ERROR) {
        return 'error'
    } else {
        return 'info'
    }
}

export const messageStrategies = {
    [NOTIFICATION_ACTIONS.MBA_UPGRADE]: payload =>
        `New version (${payload.new_version_name}) of the ${payload.mba_name} MBA is available. Consider upgrading to get the latest improvements.`,
    [NOTIFICATION_ACTIONS.ZIP_EXPORT_READY]: () =>
        `Your export file is ready to download.`,
    default: () => 'Unknown notification type',
}

export const getMessageFromType = (type, payload) => (messageStrategies[type] || messageStrategies.default)(payload)

export const actionStrategies = {
    [NOTIFICATION_ACTIONS.MBA_UPGRADE]: payload => (
        <MbaUpgradeActions token={payload.mba_token} versionId={payload.new_version_id} />
    ),
    [NOTIFICATION_ACTIONS.ZIP_EXPORT_READY]: payload => (
        <ZipExportReadyActions url={payload.url} />
    ),
    default: () => null,
}

export const getExportDownloadUrl = (payload, url) => {
    if (payload?.status === 'finished') {
        return payload.download_url || payload.url || url || null
    }
    if (payload?.action === NOTIFICATION_ACTIONS.ZIP_EXPORT_READY) {
        return payload.url || payload.download_url || url || null
    }
    return null
}

export const getActionsFromType = (type, payload, url) => {
    const downloadUrl = getExportDownloadUrl(payload, url)
    if (downloadUrl) {
        return <ZipExportReadyActions url={downloadUrl} />
    }
    return (actionStrategies[type] || actionStrategies.default)(payload)
}
